import { FormGroup, FormControl } from '@angular/forms';
var PlantingInstructionsFormComponent = /** @class */ (function () {
    function PlantingInstructionsFormComponent() {
    }
    Object.defineProperty(PlantingInstructionsFormComponent.prototype, "plantingInstructions", {
        get: function () {
            var form = this.treatmentFormGroup.get('plantingInstructions');
            return form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsFormComponent.prototype, "indexing", {
        get: function () {
            return this.plantingInstructions.value.indexing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsFormComponent.prototype, "numberOfSeedsPerCell", {
        get: function () {
            return this.numberOfSeedsPerCellControl.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsFormComponent.prototype, "numberToStart", {
        get: function () {
            return this.plantingInstructions.value.numberToStart;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsFormComponent.prototype, "numberToPots", {
        get: function () {
            return this.plantingInstructions.value.numberToPots;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsFormComponent.prototype, "numberToHarvest", {
        get: function () {
            return this.plantingInstructions.value.numberToHarvest;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsFormComponent.prototype, "numberToStartControl", {
        get: function () {
            return this.plantingInstructions.get('numberToStart');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsFormComponent.prototype, "numberToPotsControl", {
        get: function () {
            return this.plantingInstructions.get('numberToPots');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsFormComponent.prototype, "numberToHarvestControl", {
        get: function () {
            return this.plantingInstructions.get('numberToHarvest');
        },
        enumerable: true,
        configurable: true
    });
    PlantingInstructionsFormComponent.prototype.ngOnInit = function () {
    };
    PlantingInstructionsFormComponent.prototype.copyValueFrom = function (copyArgs) {
        this.plantingInstructions.patchValue(copyArgs);
        this.plantingInstructions.updateValueAndValidity();
    };
    return PlantingInstructionsFormComponent;
}());
export { PlantingInstructionsFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/planting-instructions/planting-instructions-form/planting-instructions-form.component.ts.pre-build-optimizer.js